
import { useEffect, useState, useRef } from "react";
import "./Dropdown.css";

const Dropdown_fontFamilyto = (props) => {
  const { label, value, onChange, options, inputBox, selectedID } = props;
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const [scrollToIndex, setScrollToIndex] = useState(selectedID);
  const dropdownOptionsRef = useRef(null);

  let useClickOutside = (handler) => {
    let domNode = useRef();

    useEffect(() => {
      let isHandler = (event) => {
        if (!domNode.current.contains(event.target)) {
          handler();
        }
      };

      document.addEventListener("mousedown", isHandler);

      return () => {
        document.removeEventListener("mousedown", isHandler);
      };
    });

    return domNode;
  };

  let domNode = useClickOutside(() => {
    setIsOptionsVisible(false);
  });

  useEffect(() => {
    if (isOptionsVisible && dropdownOptionsRef.current) {
      const selectedOptionElement = dropdownOptionsRef.current.children[scrollToIndex];
      if (selectedOptionElement) {
        selectedOptionElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [isOptionsVisible, scrollToIndex]);

  const handleSelected = (value, index) => {
    onChange(value);
    setIsOptionsVisible(false);
    setScrollToIndex(index);
  };

  let displayValue = value;
  const idx = options?.findIndex((opt) => opt.value === value);
  if (idx !== undefined && idx !== -1) displayValue = options[idx].label;

  return (
    <div className="DDContainer">

      {label && <span className="DD-label">{label}</span>}

      <div ref={domNode} className="DDContainer-componentFontFamily ">

        <div className=" h-full bg-transparent w-[130px] relative flex items-center justify-center" onClick={() => setIsOptionsVisible(!isOptionsVisible)}>

          <div className="DDbtnContainer h-full ">
            {isOptionsVisible ? (
              <span className="DDup-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-tabler icon-tabler-chevron-up"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 15 12 9 18 15"></polyline>
              </svg>
              </span>
            ) : (
              <span className="DDdown-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon-tabler icon-tabler-chevron-down"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              </span>
            )}
          </div>

          {/* <hr /> */}

          <div className="DDdisplayvalueFontFam h-full">
            {inputBox ? (
              <input
                type="number"
                className="dropdownInput"
                value={value}
                onChange={(evt) => {
                  if (onChange) {
                    onChange(evt.target.value);
                  }
                }}
              />
            ) : (
              displayValue
            )}
          </div>
          
        </div>
        
        {isOptionsVisible && (
          <div ref={dropdownOptionsRef} className="DD-options-Container">
            {options?.map((option, ind) => (
              <div
                key={ind}
                className="dropdown-option w-full"
                onClick={() => handleSelected(option.value, ind)}
              >
                <div className={"dropdown-label-font" + (ind === selectedID ? " dropdown-label-render-selected" : '')}>
                  {option.label}
                </div>
                <hr className="dropdown-hr" />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown_fontFamilyto;

